module.exports = __webpack_public_path__ + "static/img/1.0fdf023.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/eng/1.png
// module id = +fcW
// module chunks = 0